import React, { useState, useEffect } from "react";
import { EventContractService, EventService } from "../../../services";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { toast } from "react-toastify";
import { EventStatus } from "../../../constants/Enum";
import Swal from "sweetalert2";
import { globalConstant } from "../../../constants/globalConstant";

const EventListApproval = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getEventData();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getAllEventsPendingApproval();
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        } else {
          setFilteredData([]);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const handleApprove = async (id, isApprove) => {
    try {
      let message = isApprove ? "approve" : "reject";

      const pinkColor = globalConstant.COLOR_PINK;
      Swal.fire({
        title: "Confirmation",
        text: `Are you sure you want to ${message} event?`,
        showCancelButton: true,
        confirmButtonColor: pinkColor,
        cancelButtonColor: "#373737",
        confirmButtonText: `Yes`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          props.application.setLoading(true);
          const request = {
            eventId: id,
            eventStatus: isApprove
              ? EventStatus.Published
              : EventStatus.Rejected,
          };
          const response = await EventService.UpdateEventStatus(request);
          if (response?.isSuccess) {
            // window.location.reload();
            // await CreateContract(id);
            await getEventData();
            props.application.setLoading(false);
            toast.success(response?.data?.message);
          } else {
            props.application.setLoading(false);
            toast.error("Failed to update status.");
          }
        }
      });
    } catch (error) {
        const message = handleConsoleError(error);
       toast.error(error?.message || message);    
      props.application.setLoading(false);
    }

    // props.application.setLoading(true);
  };

  const CreateContract = async (EventId) => {
    if (EventId && EventId.length > 0) {
      await getEventContractFinalEmailAdd(EventId, "FinalEmailRetailers");
      await getEventContractFinalEmailAdd(EventId, "FinalEmailCaterers");
      await getEventContractTermAndConditionAdd(
        EventId,
        "TermsAndConditionRetailers"
      );
      await getEventContractTermAndConditionAdd(
        EventId,
        "TermsAndConditionCaterers"
      );
      await getEventContractHandBooks(EventId, "HandbookRetailers");
      await getEventContractHandBooks(EventId, "HandbookCaterers");
    }
  };

  const getEventContractFinalEmailAdd = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractFinalEmailAdd(
        EventId,
        ContractType
      );
    } catch (error) {
     const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const getEventContractTermAndConditionAdd = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractTermAndConditionAdd(
        EventId,
        ContractType
      );
    } catch (error) {
     const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const getEventContractHandBooks = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractHandBooks(
        EventId,
        ContractType
      );
    } catch (error) {
      const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const calculateSNo = (index) => offset + index + 1;

  const handlePageChange = ({ selected }) => setCurrentPage(selected);

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    return pageCount > 1 ? (
      <ReactPaginate
        previousLabel="previous"
        nextLabel="next"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
        pageCount={pageCount}
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        onPageChange={handlePageChange}
        forcePage={currentPage}
      />
    ) : null;
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
              </li>
              {/* <li className="breadcrumb-item">Content Management</li>*/}
              <li className="breadcrumb-item active">
                {" "}
                <i className="fa-solid fa-chevron-right"></i>Event Management
              </li>
            </ol>
          </nav>
        </div>

        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Event Name</th>
                <th>Event Category</th>
                <th>Event Status</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{calculateSNo(idx)}</td>
                    <td>{item?.eventName}</td>
                    <td>{item?.eventCategoryTypeName}</td>
                    <td>{item?.eventStatusName}</td>
                    <td>{formatDateENGB(item?.createdOn)}</td>
                    <td>
                      <div className="delete-create col">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(item?.id, true);
                          }}
                          style={{ marginRight: "10px" }}
                        >
                          <i
                            className="fa-solid fa-circle-check"
                            title="Approve"
                          ></i>
                        </Link>

                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            handleApprove(item?.id, false);
                          }}
                          style={{ marginRight: "10px" }}
                        >
                          <i
                            className="fa-solid fa-circle-xmark"
                            // style={{ color: "#F06548" }}
                            title="Reject"
                          ></i>
                        </Link>

                        <a
                          title="Preview"
                          href={
                            routes.EVENT_PAGE +
                            "/:eventurl".replace(":eventurl", item.url)
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginRight: "10px" }}
                        >
                          <i className="fa fa-eye"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10 mt-2">No results found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="table-footer">
          <p className="mb-3">
            <strong>Total Count: {filteredData.length}</strong>
          </p>
          {filteredData.length > 0 && renderPagination()}
        </div>
        {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Cancel Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to cancel the event '{getEventName()}' ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={confirmStatusChange}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal> */}
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventListApproval);
